var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ShiciGameLayout", [
    _c(
      "div",
      { staticClass: "backup-container" },
      [
        _c("div", { staticClass: "backup-header" }, [
          _c("h2", { staticClass: "backup-title" }, [_vm._v("诗词背诵")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "header-actions" },
            [
              _c("el-input", {
                staticStyle: { width: "300px", "margin-right": "10px" },
                attrs: {
                  placeholder: "搜索诗词标题或作者",
                  "prefix-icon": "el-icon-search",
                  clearable: "",
                },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.handleSearch.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.searchKeyword,
                  callback: function ($$v) {
                    _vm.searchKeyword = $$v
                  },
                  expression: "searchKeyword",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSearch } },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: { click: _vm.getRandomShici },
                },
                [_vm._v("随机提取")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "step-indicator" }, [
          _c(
            "div",
            {
              staticClass: "step-btn",
              class: { active: _vm.currentStep === 1 },
              on: {
                click: function ($event) {
                  _vm.currentStep = 1
                  _vm.handleStepChange()
                },
              },
            },
            [
              _c("span", { staticClass: "step-num" }, [_vm._v("1")]),
              _vm._v(" "),
              _c("span", { staticClass: "step-name" }, [_vm._v("跟读")]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "step-line" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "step-btn",
              class: { active: _vm.currentStep === 2 },
              on: {
                click: function ($event) {
                  _vm.currentStep = 2
                  _vm.handleStepChange()
                },
              },
            },
            [
              _c("span", { staticClass: "step-num" }, [_vm._v("2")]),
              _vm._v(" "),
              _c("span", { staticClass: "step-name" }, [_vm._v("猜句")]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "step-line" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "step-btn",
              class: { active: _vm.currentStep === 3 },
              on: {
                click: function ($event) {
                  _vm.currentStep = 3
                  _vm.handleStepChange()
                },
              },
            },
            [
              _c("span", { staticClass: "step-num" }, [_vm._v("3")]),
              _vm._v(" "),
              _c("span", { staticClass: "step-name" }, [_vm._v("填空")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "backup-content" }, [
          _c("div", { staticClass: "content-left" }, [
            !_vm.currentShici
              ? _c(
                  "div",
                  { staticClass: "empty-state" },
                  [
                    _c(
                      "el-icon",
                      { staticClass: "empty-icon" },
                      [_c("document")],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", [_vm._v("请随机提取或搜索一首诗词开始背诵")]),
                  ],
                  1
                )
              : _c("div", { staticClass: "shici-content" }, [
                  _c("h3", { staticClass: "shici-title" }, [
                    _vm._v(_vm._s(_vm.currentShici.title)),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "shici-author" }, [
                    _vm._v(_vm._s(_vm.currentShici.author)),
                  ]),
                  _vm._v(" "),
                  _vm.currentStep === 1
                    ? _c("div", { staticClass: "step-content" }, [
                        _c(
                          "div",
                          { staticClass: "reading-content" },
                          _vm._l(_vm.shiciChars, function (char, index) {
                            return _c(
                              "span",
                              {
                                key: index,
                                class: {
                                  "char-normal": index < _vm.currentCharIndex,
                                  "char-highlight":
                                    index === _vm.currentCharIndex,
                                  "char-future": index > _vm.currentCharIndex,
                                },
                              },
                              [_vm._v(_vm._s(char))]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "reading-controls" },
                          [
                            !_vm.isReading
                              ? _c(
                                  "el-button",
                                  { on: { click: _vm.startReading } },
                                  [_vm._v("开始跟读")]
                                )
                              : _c(
                                  "el-button",
                                  { on: { click: _vm.pauseReading } },
                                  [_vm._v("暂停")]
                                ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              { on: { click: _vm.resetReading } },
                              [_vm._v("重置")]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep === 2
                    ? _c("div", { staticClass: "step-content" }, [
                        _c(
                          "div",
                          { staticClass: "guess-content" },
                          _vm._l(
                            _vm.shiciSentences,
                            function (sentence, sentenceIndex) {
                              return _c(
                                "div",
                                {
                                  key: sentenceIndex,
                                  staticClass: "guess-line",
                                  class: {
                                    "sentence-hidden":
                                      (sentenceIndex + _vm.startWithFirst) %
                                        2 !==
                                      0,
                                  },
                                },
                                [
                                  (sentenceIndex + _vm.startWithFirst) % 2 === 0
                                    ? [_vm._v(_vm._s(sentence))]
                                    : _vm._l(
                                        sentence.split(""),
                                        function (char, charIndex) {
                                          return _c(
                                            "span",
                                            {
                                              key: charIndex,
                                              staticClass: "hidden-underline",
                                              class: {
                                                "hint-char":
                                                  _vm.guessedChars[
                                                    sentenceIndex
                                                  ] &&
                                                  _vm.guessedChars[
                                                    sentenceIndex
                                                  ] > charIndex,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.guessedChars[
                                                    sentenceIndex
                                                  ] &&
                                                    _vm.guessedChars[
                                                      sentenceIndex
                                                    ] > charIndex
                                                    ? char
                                                    : _vm.isPunctuation(char)
                                                    ? char
                                                    : "_"
                                                )
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                ],
                                2
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep === 3
                    ? _c("div", { staticClass: "step-content" }, [
                        _c(
                          "div",
                          { staticClass: "fill-content" },
                          _vm._l(
                            _vm.shiciSentences,
                            function (sentence, sentenceIndex) {
                              return _c(
                                "div",
                                {
                                  key: sentenceIndex,
                                  staticClass: "fill-line",
                                },
                                _vm._l(
                                  sentence.split(""),
                                  function (char, charIndex) {
                                    return _c(
                                      "span",
                                      {
                                        key: charIndex,
                                        staticClass: "hidden-underline",
                                        class: {
                                          "hint-char":
                                            _vm.guessedChars[
                                              sentenceIndex + "_" + charIndex
                                            ],
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.guessedChars[
                                              sentenceIndex + "_" + charIndex
                                            ]
                                              ? char
                                              : _vm.isPunctuation(char)
                                              ? char
                                              : "_"
                                          )
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "options-float" }, [
            _c("div", { staticClass: "options-panel" }, [
              _c("h4", [_vm._v("选项配置")]),
              _vm._v(" "),
              _vm.currentStep === 1
                ? _c("div", { staticClass: "step-options" }, [
                    _c(
                      "div",
                      { staticClass: "option-item" },
                      [
                        _c("span", { staticClass: "option-label" }, [
                          _vm._v("字间停顿时间"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "time-presets" },
                          _vm._l([200, 400, 600, 800], function (time) {
                            return _c(
                              "el-button",
                              {
                                key: time,
                                staticClass: "time-btn",
                                attrs: {
                                  type:
                                    _vm.charInterval === time
                                      ? "primary"
                                      : "default",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.charInterval = time
                                  },
                                },
                              },
                              [_vm._v(_vm._s(time) + "ms")]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("el-slider", {
                          attrs: {
                            min: 100,
                            max: 1000,
                            step: 100,
                            "show-input": "",
                          },
                          model: {
                            value: _vm.charInterval,
                            callback: function ($$v) {
                              _vm.charInterval = $$v
                            },
                            expression: "charInterval",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep === 2
                ? _c("div", { staticClass: "step-options" }, [
                    _c("div", { staticClass: "option-item" }, [
                      _c("span", { staticClass: "option-label" }, [
                        _vm._v("第一个隐藏"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "time-presets" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "time-btn",
                              attrs: {
                                type:
                                  _vm.startWithFirst === 0
                                    ? "primary"
                                    : "default",
                                size: "small",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.startWithFirst = 0
                                },
                              },
                            },
                            [_vm._v("第一句")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "time-btn",
                              attrs: {
                                type:
                                  _vm.startWithFirst === 1
                                    ? "primary"
                                    : "default",
                                size: "small",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.startWithFirst = 1
                                },
                              },
                            },
                            [_vm._v("第二句")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "option-item" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "big-btn hint-btn-top",
                            attrs: { type: "info" },
                            on: { click: _vm.showHint },
                          },
                          [_vm._v("提示")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep === 3
                ? _c("div", { staticClass: "step-options" }, [
                    _c(
                      "div",
                      { staticClass: "option-item" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "big-btn hint-btn-top",
                            attrs: { type: "info" },
                            on: { click: _vm.showFillHint },
                          },
                          [_vm._v("提示")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.showSearchResults,
              title: "选择诗词",
              width: "500px",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showSearchResults = $event
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "search-results" },
              _vm._l(_vm.searchResults, function (shici, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "search-result-item",
                    on: {
                      click: function ($event) {
                        return _vm.selectShici(shici)
                      },
                    },
                  },
                  [
                    _c("h3", [
                      _vm._v(_vm._s(shici.title || shici.Title || "无标题")),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(shici.author || shici.Author || "无作者")),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "content-preview" }, [
                      _vm._v(
                        _vm._s(
                          (shici.content || shici.Content || "").substring(
                            0,
                            50
                          )
                        ) + "..."
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        _vm.showSearchResults = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }